import axios, { AxiosResponse } from "axios";
import { DateTime } from "luxon";
import { TypeHelper } from "../../Common/TypeHelper";
import { ApiError } from "../ApiError";
import { appContext } from "../../AppContext";
import apis from "../apis";
import { DateHelper } from "../../Common/DateHelper";
import { IDeleteBookingResponse } from "./DeleteV1BookingEndpoint";
import { IbssRequestConfig } from "../ApiClient";

export class DeleteV2BookingEndpoint implements IDeleteV2BookingEndpoint
{
    public async execute(buildingId: number, bookingId: string, suppressErrorPopup: boolean): Promise<IDeleteBookingResponse>
    {
        try
        {
            const axiosConfig: IbssRequestConfig = { suppressErrorPopup: suppressErrorPopup };
            const response = await axios.patch<IDeleteBookingResponse>(apis.allApiv2 + buildingId + `/bookings/` + bookingId + `/cancel`, null, axiosConfig);
            return response.data;
        }
        catch (error: any)
        {
            throw ApiError.fromAxiosResponse(error.response as AxiosResponse);
        }
    }
}

export interface IDeleteV2BookingEndpoint
{
    execute(buildingId: number, bookingId: string, suppressErrorPopup: boolean): Promise<IDeleteBookingResponse>;
}
